import * as React from 'react';
import type { SVGProps } from 'react';
const SvgMail = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={20}
    height={20}
    fill="none"
    viewBox="0 0 20 20"
    {...props}
  >
    <mask
      id="a"
      width={20}
      height={20}
      x={0}
      y={0}
      maskUnits="userSpaceOnUse"
      style={{
        maskType: 'alpha',
      }}
    >
      <path fill="#D9D9D9" d="M0 0h20v20H0z" />
    </mask>
    <g mask="url(#a)">
      <path
        fill="#5C78C7"
        d="M3.589 16.25q-.632 0-1.07-.437a1.45 1.45 0 0 1-.437-1.07V5.256q0-.63.438-1.069a1.45 1.45 0 0 1 1.069-.437h12.82q.63 0 1.069.438.438.437.437 1.068v9.487q0 .633-.437 1.07a1.45 1.45 0 0 1-1.069.437zM16.665 6.202l-6.26 4.008a1 1 0 0 1-.2.086.7.7 0 0 1-.413 0 1 1 0 0 1-.199-.086l-6.26-4.008v8.542a.25.25 0 0 0 .071.184.25.25 0 0 0 .185.072h12.82a.25.25 0 0 0 .184-.072.25.25 0 0 0 .072-.185zM10 9.167 16.537 5H3.46zM3.332 6.394v-.953.025-.026z"
      />
    </g>
  </svg>
);
export default SvgMail;
